module.exports = __webpack_public_path__ + "static/media/thank-you-desk.c50fd52a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thank-you-desk.svg
// module id = 251
// module chunks = 0